import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';

// Shared by card templates, orders, and card management limit fields.
const IntegerLimitInput = ({ value, onChange, ...props }) => {
  const [draft, setDraft] = useState(null);
  const [warning, setWarning] = useState('');
  const [pendingValue, setPendingValue] = useState(null);

  useEffect(() => {
    if (pendingValue === null) return;

    const actualValue = Number(value);
    const wasLimited = value !== '' && value !== null && value !== undefined &&
      Number.isFinite(actualValue) && actualValue < pendingValue.rounded;

    if (wasLimited) {
      const roundedMessage = pendingValue.wasDecimal
        ? `Decimal rounded up to ${pendingValue.rounded}. ` : '';
      setWarning(`${roundedMessage}Maximum allowed is ${actualValue}; value set to ${actualValue}.`);
    } else {
      setWarning(pendingValue.wasDecimal ? 'Decimal rounded up to the nearest whole number.' : '');
    }
    setPendingValue(null);
  }, [value, pendingValue]);

  const handleChange = (event) => {
    const raw = event.target.value;
    if (raw === '') {
      setDraft(null);
      setWarning('');
      setPendingValue(null);
      onChange({ target: { value: '' } });
      return;
    }

    // Keep a trailing decimal point briefly so a typed fraction can be completed.
    if (/^\d+\.$/.test(raw)) {
      setDraft(raw);
      return;
    }

    if (!/^\d+(?:\.\d+)?$/.test(raw)) return;
    const numericValue = Number(raw);
    if (!Number.isSafeInteger(Math.ceil(numericValue))) return;

    const rounded = Math.ceil(numericValue);
    setDraft(null);
    setPendingValue({ rounded, wasDecimal: raw.includes('.') });
    onChange({ target: { value: String(rounded) } });
  };

  return (
    <>
      <Form.Control
        {...props}
        type="text"
        inputMode="decimal"
        value={draft === null ? (value ?? '') : draft}
        onChange={handleChange}
        onBlur={() => setDraft(null)}
      />
      {warning && <small role="alert" className="text-danger d-block mt-1">{warning}</small>}
    </>
  );
};

export default IntegerLimitInput;
